import { Injectable } from '@angular/core';


export class SkyModalConfiguration {

  public fullPage?: boolean;
  public size?: string;
  public ariaDescribedBy?: string;
  public ariaLabelledBy?: string;
  public tiledBody?: boolean;
  public helpKey?: string;

  constructor() {
    this.fullPage = this.fullPage;
    this.size = 'medium';
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
